export default __webpack_public_path__ + "media/zurb/img/legacy/plunk/about-3-taps-f96daa88d18681ffd3c547833371ba3e.jpg";